export const getChatGroupStyles = (isDashboardUser: boolean) => {
    const messageAlignment = isDashboardUser ? 'flex-start' : 'flex-end';

    return {
        containerStyles: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: messageAlignment
        } as React.CSSProperties,
        messagesContainer: {
            margin: '0px 5px 10px 5px',
            flex: 10,
            display: 'flex',
            flexDirection: 'column',
            alignItems: messageAlignment,
            order: isDashboardUser ? 2 : 1
        } as React.CSSProperties,
        imageStyles: {
            marginTop: 'auto',
            order: isDashboardUser ? 1 : 2
        }
    };
};

export default {
    groupContent: {
        display: 'flex',
        maxWidth: '70%'
    },
    chatWindowContainer: {
        maxWidth: 800,
        overflow: 'auto'
    },
    modalContent: {
        overflow: 'unset'
    },
    emptyContent: {
        height: '30vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    messageBubble: {
        backgroundColor: '#eee',
        borderRadius: 20,
        margin: '1px 0px',
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 14,
        paddingRight: 14,
        color: '#000'
    },
    messageText: {
        fontSize: 14,
        margin: 0,
        wordBreak: 'break-word'
    } as React.CSSProperties
};
